import React, { useState, useCallback, useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import LoginPromoModal from '../../../modal/login-promo';
import { Button, HelpfulText } from './styles';
import { useIsAuthenticated } from '../../../../hooks/use-is-authenticated';
import { UserReview } from '../../../../types';
import { ButtonIcon } from '@prisjakt/ui/button/variants';
import { IconLikeFilled, IconLikeOutlined } from '@prisjakt/ui/icon';

type Props = {
  className?: string;
  onClick: () => void;
  liked: boolean;
  likes: UserReview['likeScore'];
  size?: number;
  text?: string;
};

const HelpfulButton = ({
  className,
  onClick,
  liked,
  likes,
  size = 20,
  text,
}: Props) => {
  const { t } = useContext(AppContext);
  const [likeScore, setLikeScore] = useState(likes);
  const isAuthenticated = useIsAuthenticated();
  const [showLoginPromo, setShowLoginPromo] = useState(false);

  const handler = useCallback(() => {
    if (!isAuthenticated) {
      setShowLoginPromo(true);
      return;
    }

    onClick();

    // Fake a +1 in like score as the real data is not updated in real time
    if (!liked) {
      setLikeScore((likes || 0) + 1);
    }
  }, [onClick, likes, liked, isAuthenticated]);

  const hideLoginPromo = useCallback(() => {
    setShowLoginPromo(false);
  }, []);

  return (
    <>
      {showLoginPromo ? (
        <LoginPromoModal isOpen onRequestClose={hideLoginPromo} />
      ) : null}

      <Button onClick={handler} liked={liked} className={className}>
        <HelpfulText>{text || t('reviews', 'button.helpful')}</HelpfulText>
        {liked ? (
          <ButtonIcon>
            <IconLikeFilled size={size} />
            {likeScore || 1}
          </ButtonIcon>
        ) : (
          <ButtonIcon>
            <IconLikeOutlined size={size} />
            {likes || null}
          </ButtonIcon>
        )}
      </Button>
    </>
  );
};

export default HelpfulButton;
